import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {NotFoundComponent} from "./not_found.component";
import {AuthGuard} from "./core/authentication/auth.gaurd";
import {AuthService} from "./core/authentication/auth.service";
const routes: Routes = [
  {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
  {
    path: 'dashboard',
    loadChildren: '../app/components/dashboard/dashboard.module#DashBoardModule',
    pathMatch: 'prefix'
  },
  {
    path: 'user',
    loadChildren: '../app/components/login/login.module#LoginModule',
    pathMatch: 'prefix'
  },
  {path: '404', component: NotFoundComponent},
  {path: '**', redirectTo: '404'}


];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthService, AuthGuard]
})
export class AppRoutingModule {
}
